import { BeehiivPublicationIds, BeehiivPublicationSlugs } from '@blockworks/platform/api/beehiiv';

import EditorialConfig from '@/editorial-config';

export enum Frequency {
    Daily = 'daily',
    Weekdays = 'weekdays',
    Monthly = 'monthly',
}

type NewsletterMeta = {
    title: string;
    description: string;
    og_image?: any;
    twitter_card?: any;
    imageUrl?: string;
    key: BeehiivPublicationIds;
    postArchive: boolean;
    frequency: Frequency;
};

export const includedSlugValues = [
    BeehiivPublicationSlugs.TheBreakdown,
    BeehiivPublicationSlugs.ZeroXResearch,
    BeehiivPublicationSlugs.Empire,
    BeehiivPublicationSlugs.Lightspeed,
    BeehiivPublicationSlugs.ForwardGuidance,
    BeehiivPublicationSlugs.TheDrop,
    BeehiivPublicationSlugs.SupplyShock,
] as const satisfies readonly BeehiivPublicationSlugs[];

export type IncludedBeehivPublicationSlugs = (typeof includedSlugValues)[number];

export const newsletterMetaBySlug: Record<IncludedBeehivPublicationSlugs, NewsletterMeta> = {
    [BeehiivPublicationSlugs.TheBreakdown]: {
        title: 'The Breakdown',
        description: 'Decoding crypto and the markets. Daily, with Byron Gilliam.',
        og_image: [
            {
                width: 1330,
                height: 912,
                type: 'image/jpeg',
                url: `${EditorialConfig.SITE_URL}/images/newsletter/TheBreakdown_NewsletterPageOG.png`,
            },
        ],
        imageUrl: '/images/newsletter/TheBreakdown_Newsletter.png',
        twitter_card: 'summary_large_image',
        key: BeehiivPublicationIds.TheBreakdown,
        postArchive: true,
        frequency: Frequency.Daily,
    },
    [BeehiivPublicationSlugs.ZeroXResearch]: {
        title: '0xResearch',
        description:
            'Alpha directly in your inbox. Market highlights, data, degen trade ideas, governance updates, token performance and more.',
        og_image: [
            {
                width: 1330,
                height: 912,
                type: 'image/jpeg',
                url: `${EditorialConfig.SITE_URL}/images/newsletter/0xResearch_NewsletterPageOG.png`,
            },
        ],
        imageUrl: '/images/newsletter/0xResearch_NewsletterPage_v2.png',
        twitter_card: 'summary_large_image',
        key: BeehiivPublicationIds.ZeroXResearch,
        postArchive: true,
        frequency: Frequency.Weekdays,
    },
    [BeehiivPublicationSlugs.Empire]: {
        title: 'Empire',
        description: 'Start your morning with the top news and analysis to inform your day in crypto.',
        og_image: [
            {
                type: 'image/png',
                url: `${EditorialConfig.SITE_URL}/images/newsletter/EmpireOG_v2.png`,
            },
        ],
        imageUrl: '/images/newsletter/Empire_NewsletterPage_v3.png',
        twitter_card: 'summary_large_image',
        key: BeehiivPublicationIds.Empire,
        postArchive: true,
        frequency: Frequency.Weekdays,
    },
    [BeehiivPublicationSlugs.TheDrop]: {
        title: 'The Drop',
        description: 'A newsletter on crypto’s consumer layer, for builders, VCs, and insiders.',
        twitter_card: 'summary_large_image',
        imageUrl: '/images/newsletter/TheDrop_NewsletterPage.png',
        key: BeehiivPublicationIds.TheDrop,
        postArchive: true,
        frequency: Frequency.Weekdays,
    },
    [BeehiivPublicationSlugs.Lightspeed]: {
        title: 'Lightspeed',
        description:
            "Built for Solana investors, developers and community members. The latest from one of crypto's hottest networks.",
        og_image: [
            {
                type: 'image/png',
                url: `${EditorialConfig.SITE_URL}/images/newsletter/Lightspeed_NewsletterPageOG_v2.png`,
            },
        ],
        imageUrl: '/images/newsletter/Lightspeed_NewsletterPage_v2.png',
        twitter_card: 'summary_large_image',
        key: BeehiivPublicationIds.Lightspeed,
        postArchive: true,
        frequency: Frequency.Weekdays,
    },
    [BeehiivPublicationSlugs.ForwardGuidance]: {
        title: 'Forward Guidance',
        description:
            'Reporting and analysis on the growing intersection of crypto and macroeconomics, policy and finance.',
        og_image: [
            {
                type: 'image/png',
                url: `${EditorialConfig.SITE_URL}/images/newsletter/FG_NL.png`,
            },
        ],
        imageUrl: '/images/newsletter/Forwardguidance_NewsletterPage.png',
        twitter_card: 'summary_large_image',
        key: BeehiivPublicationIds.ForwardGuidance,
        postArchive: true,
        frequency: Frequency.Weekdays,
    },
    [BeehiivPublicationSlugs.SupplyShock]: {
        title: 'Supply Shock',
        description:
            'Join Rizzo, The Bitcoin Historian, as we detail Bitcoin’s rise from internet plaything worth less than a penny to global phenomenon disrupting money as we know it.',
        og_image: [
            {
                type: 'image/png',
                url: `${EditorialConfig.SITE_URL}/images/newsletter/Supply_NL.png`,
            },
        ],
        imageUrl: '/images/newsletter/SupplyShock_NewsletterPage.png',
        twitter_card: 'summary_large_image',
        key: BeehiivPublicationIds.SupplyShock,
        postArchive: true,
        frequency: Frequency.Weekdays,
    },
};
